import dayjs from 'dayjs'
import { Event, EventToCompany } from 'src/models/Event'
import { PromisedType } from 'src/utils/types'
import useSWR, { SWRConfiguration } from 'swr'
import { ApiClient, fetcher } from './client'
import { getEvent, getEvents, POST_EVENT } from './endpoints'
import {
  EventItemData,
  EventsData,
  EventToCompanyRequest,
  Event as ServerEvent,
} from './types/event'

const eventDataFetcher = async (url: string) => {
  const res: EventsData = await fetcher(url)
  return {
    events: res.events.map(toEvent),
    eventTotal: res.eventTotal,
  }
}

export const useEventList = (
  config: Partial<SWRConfiguration> = {},
  pageIndex: number,
) =>
  useSWR<PromisedType<typeof eventDataFetcher>>(
    `${getEvents(pageIndex, 15)}`,
    eventDataFetcher,
    config,
  )

export const toEvent = (data: ServerEvent): Event => ({
  id: data.id,
  name: data.name,
  status: data.status,
  openingAt: dayjs(data.openingAt),
  imageFile: data.imageFile,
  summary: data.summary || '',
  flowing: data.flowing || '',
  content: data.content || '',
  attention: data.attention || '',
  entried: data.entried,
  googleFormUrl: data.googleFormUrl,
  registrationType: data.registrationType,
})

const eventItemFetcher = async (url: string): Promise<Event | undefined> => {
  const res: EventItemData = await fetcher(url)
  return res.event ? toEvent(res.event) : undefined
}

export const useEventItemData = (
  id: number,
  config: Partial<SWRConfiguration> = {},
) => useSWR<Event | undefined>(getEvent(id), eventItemFetcher, config)

export const joinEvent = async (eventToCompany: EventToCompany) => {
  const body = joinEventRequest(eventToCompany)
  const res = await ApiClient.post(POST_EVENT, body)
  if (res.error) return res
  return res
}

export const joinEventRequest = (
  eventToCompany: EventToCompany,
): Partial<EventToCompanyRequest> => ({
  event_to_company: {
    event_id: eventToCompany.eventId,
    admin_name: eventToCompany.adminName,
    position: eventToCompany.positionText,
    email: eventToCompany.email,
    phone_number: eventToCompany.phoneNumber,
    note: eventToCompany.note,
  },
})
